module.exports = __webpack_public_path__ + "img/hyundai_avante_new.4419d239.jpg";